import React from "react"
import badge from "badges/planning-the-future.svg"
import { BadgeImage } from "backpack/badges/styled"

const PlanningTheFuture = props => <BadgeImage src={badge} {...props} />

export default PlanningTheFuture
